// removed by extract-text-webpack-plugin
module.exports = {"component":"_3K6ZPF10EMRdHOpD7sW1Rm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/CardPage/CardProducer/cardProducer.css
// module id = 1267
// module chunks = 2